import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["quantity", "stockRow", "createButton", "warningMessage"]
  static values = {
    candleId: Number
  }

  connect() {
    console.log('Fabrication stock controller connected')
    this.updateStockTable()
  }

  createLog(event) {
    event.preventDefault()
    const quantity = parseInt(this.quantityTarget.value) || 1
    const url = `/crafting/candle_logs/new?candle_id=${this.candleIdValue}&quantity=${quantity}`
    window.location.href = url
  }

  updateStockTable() {
    const quantity = parseInt(this.quantityTarget.value) || 1

    fetch(`/crafting/candles/${this.candleIdValue}/fabrication_stock?quantity=${quantity}`, {
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      // Check if all stock is sufficient
      const hasSufficientStock = data.stock_status.every(status => status.sufficient)

      // Update each row with the new stock data
      data.stock_status.forEach((status, index) => {
        const row = this.stockRowTargets[index]
        if (!row) return

        const neededCell = row.querySelector('.needed-weight')
        const stockCell = row.querySelector('.stock-status')

        // Update needed column
        neededCell.textContent = status.needed

        // Update stock status with color
        if (status.sufficient) {
          stockCell.classList.remove('table-danger')
          stockCell.classList.add('table-success')
          stockCell.innerHTML = `<i class="fa fa-check text-success me-2"></i>${status.available}`
        } else {
          stockCell.classList.remove('table-success')
          stockCell.classList.add('table-danger')
          stockCell.innerHTML = `<i class="fa fa-times text-danger me-2"></i>${status.available}`
        }
      })

      // Enable/disable the create button based on stock availability
      if (this.hasCreateButtonTarget) {
        this.createButtonTarget.disabled = !hasSufficientStock
      }

      // Show/hide warning message
      if (this.hasWarningMessageTarget) {
        if (hasSufficientStock) {
          this.warningMessageTarget.classList.add('d-none')
        } else {
          this.warningMessageTarget.classList.remove('d-none')
        }
      }
    })
    .catch(error => {
      console.error('Error fetching stock:', error)
    })
  }
}

